module.exports = __webpack_public_path__ + "assets/img/provider-poster-02.ab5ec62f.png";